import "../../../../styles/searchHome.css";
import { useState } from "react";
import { useNavigate } from "react-router-dom";

export default function SearchHome() {
  const [search, setSearch] = useState("");

  const navigate = useNavigate();

  const selectOpen = (e) => {
    e.preventDefault();
    navigate(`/pesquisar/${search}/`);
  };

  return (
    <div
      className="background-global"
      id="back-search-main-portal"
      style={{
        backgroundImage: "url(/imagens/01.png)",
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
      }}
    >
      <div className="container-search-txt">
        <div className="container-search-txt1"></div>
      </div>
      <form className="container-search">
        <input
          type="text"
          placeholder="Buscar"
          name="search-main"
          className="input-search"
          onChange={(e) => setSearch(e.target.value)}
        />
        <button onClick={(e) => selectOpen(e)} className="link-search">
          <img
            src="/icons/search.svg"
            alt="logo buscar"
            className="svg-search"
          />
        </button>
      </form>
      <span
        style={{
          fontSize: "10px",
          position: "absolute",
          bottom: "0px",
          right: "10px",
          color: "#f5f5f5",
        }}
      >
        Imagem de:
      </span>
    </div>
  );
}
